<template>
    <UIDropDown :additional-top="26">
        <template #trigger>
            <button class="user-info__settings">
                <img src="@/assets/icons/settings.svg" />
            </button>
        </template>

        <template #menu>
            <HeaderMainSettings
                v-if="activeMenu === 'main'"
                @change-dealer="activeMenu = 'change-dealer'"
            />

            <HeaderChangeDealerSettings
                v-if="activeMenu === 'change-dealer'"
                @main="activeMenu = 'main'"
            />
        </template>
    </UIDropDown>
</template>

<script setup lang="ts">
    import { ref } from 'vue';

    import UIDropDown from '@/components/ui/UIDropDown/UIDropDown.vue';

    import HeaderMainSettings from '@/layouts/MainLayout/components/HeaderMainSettings/HeaderMainSettings.vue';
    import HeaderChangeDealerSettings from '@/layouts/MainLayout/components/HeaderChangeDealerSettings/HeaderChangeDealerSettings.vue';

    const activeMenu = ref<string>('main');
</script>
